import React from 'react';
import { ArrowRight, Star, Shield, Sparkles, CheckCircle2, Menu, X, Phone, Instagram, MapPin, Quote, Gift, Snowflake } from 'lucide-react';
import { Button } from "./components/ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./components/ui/carousel";
import { Card, CardContent } from "./components/ui/card";
import { Dialog, DialogContent, DialogTrigger } from "./components/ui/dialog";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./components/ui/accordion";

const NaverBookingCTA = ({ className = "" }) => (
  <div className={`flex flex-col items-center w-full md:w-auto ${className}`}>
    <button 
      onClick={() => window.open("https://map.naver.com/p/entry/place/1096514067", "_blank", "noopener,noreferrer")}
      className="w-full md:w-auto bg-[#03C75A] text-white font-bold py-4 px-8 rounded-xl shadow-lg hover:brightness-105 transition-all flex items-center justify-center gap-2 text-lg"
    >
      <span className="font-extrabold">N</span>
      <span>네이버에서 예약하기</span>
    </button>
    <div className="mt-3 text-center space-y-1">
      <p className="text-sm font-medium text-gray-700">
        버튼 클릭 → 네이버 페이지 이동 → ‘상담예약’ 클릭
      </p>
      <p className="text-xs text-gray-500 flex items-center justify-center gap-1">
        <Shield className="w-3 h-3" />
        네이버 공식 페이지에서 안전하게 예약 가능합니다
      </p>
    </div>
  </div>
);

const NaverPlaceLink = ({ className = "" }) => (
  <button 
    onClick={() => window.open("https://map.naver.com/p/entry/place/1096514067", "_blank", "noopener,noreferrer")}
    className={`w-full md:w-auto bg-white text-[#03C75A] border-2 border-[#03C75A] font-bold py-3 px-6 rounded-xl hover:bg-green-50 transition-all flex items-center justify-center gap-2 ${className}`}
  >
    <span>네이버 플레이스 보기</span>
  </button>
);
const LandingPage = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [isPlaying, setIsPlaying] = React.useState(false);

  // Images
  const images = {
    logo: "https://customer-assets.emergentagent.com/job_fe49020f-8628-4ca3-a2d0-fa72b46b9ede/artifacts/bhe767e2_KakaoTalk_20250830_225802827.png",
    coachSitting: "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/dkrsy6qn_Screenshot_20250919_132816_Instagram.jpg",
    coachSelfie: "https://customer-assets.emergentagent.com/job_fe49020f-8628-4ca3-a2d0-fa72b46b9ede/artifacts/1tqhhrym_KakaoTalk_20250830_142420265_23.jpg",
    heroBg: "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/kc91ztu8_KakaoTalk_20250830_142422723_01.jpg",
    girlKid: "https://customer-assets.emergentagent.com/job_fe49020f-8628-4ca3-a2d0-fa72b46b9ede/artifacts/f8ttyjaq_1.jfif",
    boyKid: "https://customer-assets.emergentagent.com/job_fe49020f-8628-4ca3-a2d0-fa72b46b9ede/artifacts/pmi4fyio_6.jfif",
    gallery1: "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/dzflpk7i_20250623_125317.jpg",
    gallery2: "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/j14kf4w4_479724756_17856190326380932_4220339512121640517_n.webp.jpg",
    gallery3: "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/i7thvg15_479996197_17856190353380932_5565306312970967091_n.webp.jpg",
    gallery4: "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/pkc0bn13_Clean%20%26%20professional_20250919_120455_0000.png",
    feature1: "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/s5sv22xf_20250919_133738.jpg",
    feature2: "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/a6eljcgf_20250919133124.png",
    feature3: "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/u5hznywr_before%20and%20after%201-1.png",
    naverMapLogo: "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/na9l4hfc_image.png"
  };

  const reviews = [
    "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/5ctfwwrj_Screenshot_1.jpg",
    "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/ygqsesir_Screenshot_2.jpg",
    "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/m2jvd3wx_Screenshot_3.jpg",
    "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/u338dp4q_Screenshot_4.jpg",
    "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/hggfilu1_Screenshot_5.jpg",
    "https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/xykmws28_Screenshot_20250911_144000_Instagram.jpg"
  ];

  const handleConsultation = () => {
    window.location.href = "https://booking.naver.com/booking/10/bizes/1337119/items/6484304";
  };

  const handleNaverBooking = () => {
    window.open("https://map.naver.com/p/entry/place/1096514067", "_blank", "noopener,noreferrer");
  };

  return (
    <div className="min-h-screen w-full overflow-x-hidden relative">
      {/* Global Fixed Background */}
      <div className="fixed inset-0 z-[-1]">
        <div 
            className="absolute inset-0 bg-cover bg-[center_top_30%] bg-no-repeat opacity-60"
            style={{ backgroundImage: `url(${images.heroBg})` }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-white/80 to-white/60"></div>
      </div>

      {/* Sticky Call Button (Mobile Only) */}
      <div className="fixed bottom-4 right-4 left-4 z-50 md:hidden">
        <a href="tel:010-9879-0818" className="flex items-center justify-center gap-2 w-full bg-[#E63946] text-white font-bold py-4 rounded-full shadow-2xl hover:brightness-110 transition-all">
          <Phone className="w-5 h-5 fill-white" />
          전화로 상담하기
        </a>
      </div>

      {/* Navigation */}
      <nav className="absolute left-0 right-0 z-50 px-4 py-4">
        <div className="w-full max-w-7xl mx-auto bg-white/90 backdrop-blur-md rounded-[25px] px-5 md:px-6 py-3 flex items-center shadow-md border border-blue-50 relative min-h-[64px] overflow-hidden">
          {/* Logo */}
          <a href="/" className="flex min-w-0 items-center gap-2 whitespace-nowrap">
             <span className="text-[#1A4392] font-['Poppins'] font-extrabold text-xl md:text-2xl tracking-tight">온더그라운드 주짓수</span>
          </a>
          
          {/* Desktop Menu - Right Aligned */}
          <div className="hidden md:flex items-center gap-6 ml-auto">
            <a href="/suseong-gu-english-sports/" className="text-[#374151] hover:text-[#1A4392] transition-colors font-medium">영어 스포츠</a>
            <a href="/suseong-gu-elementary-exercise-academy/" className="text-[#374151] hover:text-[#1A4392] transition-colors font-medium">초등 운동</a>
            <a href="/english-summer-activities-daegu/" className="text-[#374151] hover:text-[#1A4392] transition-colors font-medium">여름방학 활동</a>
            <a href="#features" className="text-[#374151] hover:text-[#1A4392] transition-colors font-medium">특징</a>
            <a href="#program" className="text-[#374151] hover:text-[#1A4392] transition-colors font-medium">프로그램</a>
            <a href="#reviews" className="text-[#374151] hover:text-[#1A4392] transition-colors font-medium">후기</a>
            <button onClick={handleConsultation} className="btn-primary text-sm py-2 px-5 min-h-[40px]">
              상담 예약
            </button>
          </div>

          {/* Mobile Menu Toggle - Right Aligned */}
          <button className="md:hidden text-[#1A4392] ml-auto" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X /> : <Menu />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="absolute top-20 left-4 right-4 bg-white/95 backdrop-blur-md rounded-2xl p-6 shadow-xl md:hidden flex flex-col gap-4 border border-blue-100 animate-in slide-in-from-top-2">
            <a href="/suseong-gu-english-sports/" className="text-[#374151] font-medium py-2" onClick={() => setIsMenuOpen(false)}>영어 스포츠</a>
            <a href="/suseong-gu-elementary-exercise-academy/" className="text-[#374151] font-medium py-2" onClick={() => setIsMenuOpen(false)}>초등 운동</a>
            <a href="/english-summer-activities-daegu/" className="text-[#374151] font-medium py-2" onClick={() => setIsMenuOpen(false)}>여름방학 활동</a>
            <a href="#features" className="text-[#374151] font-medium py-2" onClick={() => setIsMenuOpen(false)}>특징</a>
            <a href="#program" className="text-[#374151] font-medium py-2" onClick={() => setIsMenuOpen(false)}>프로그램</a>
            <a href="#reviews" className="text-[#374151] font-medium py-2" onClick={() => setIsMenuOpen(false)}>후기</a>
            <button onClick={handleConsultation} className="btn-primary w-full">
              상담 예약하기
            </button>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-4 overflow-hidden min-h-[80vh] flex items-center">
        <div className="w-full max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10">
          
          {/* Video Section - Left on Desktop, Top on Mobile */}
          <div className="relative group order-1 mx-auto min-w-0 max-w-[calc(100vw-3rem)] md:max-w-full">
             <div className="absolute -inset-4 bg-[#1A4392] rounded-[40px] -rotate-3 opacity-20 blur-lg"></div>
             
             {/* Click Me Indicator */}
             {!isPlaying && (
             <div className="absolute top-[30%] left-1/2 -translate-x-1/2 z-20 flex flex-col items-center animate-bounce pointer-events-none">
                <span className="font-['Poppins'] font-bold text-[#E63946] text-lg md:text-xl bg-white px-3 py-1 rounded-full shadow-md whitespace-nowrap mb-1 md:mb-2 transform -rotate-6 border border-red-100">
                  Click Me! 🎬
                </span>
                <ArrowRight className="w-8 h-8 md:w-12 md:h-12 text-[#E63946] fill-[#E63946] rotate-90" />
             </div>
             )}

             <video 
                src="https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/7zj9r6yx_1122.mp4"
                controls
                playsInline
                onPlay={() => setIsPlaying(true)}
                className="rounded-[32px] shadow-2xl w-full max-w-[calc(100vw-3rem)] md:max-w-full aspect-[4/5] object-cover bg-black border-4 border-white relative z-10"
             >
                Your browser does not support the video tag.
             </video>
          </div>

          {/* Text Content - Right on Desktop, Bottom on Mobile */}
          <div className="space-y-8 animate-in slide-in-from-bottom-10 duration-700 order-2 text-center md:text-left min-w-0 max-w-[calc(100vw-2rem)] md:max-w-full">
            <div className="inline-block max-w-full bg-[#E63946] text-white px-4 py-1 rounded-full font-bold text-xs md:text-sm mb-2 shadow-md leading-relaxed">
              대구 수성구 만촌동 영어 스포츠
            </div>
            <h1 className="font-bold leading-tight text-[#1A4392] text-3xl sm:text-4xl md:text-6xl drop-shadow-sm break-words">
              아이의 진짜 힘은<br />
              <span className="text-[#1A4392]">마음에서 시작됩니다.</span>
            </h1>
            <p className="text-base md:text-xl text-[#374151] leading-relaxed font-medium">
              영어 스포츠와 영어 여름방학 활동을<br />
              찾는 가족을 위한 만촌역 3번 출구 232m<br />
              영어 주짓수 수업입니다.
            </p>
            
            <div className="flex flex-col items-center gap-6 pt-4 w-full">
              <NaverBookingCTA />
              <button onClick={handleConsultation} className="btn-secondary w-full md:w-auto bg-white/50 backdrop-blur-sm">
                체험 수업 신청
              </button>
            </div>

            <div className="flex items-center justify-center md:justify-start gap-4 pt-4 text-[#1A4392] font-medium">
               <div className="flex items-center gap-2">
                 <Phone className="w-5 h-5" /> 010-9879-0818
               </div>
            </div>

            <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200/50">
              <div className="flex items-center justify-center md:justify-start gap-2 text-sm font-medium text-[#555]">
                <Shield className="w-5 h-5 text-[#1A4392]" />
                <span>체육시설 종합보험 가입</span>
              </div>
              <div className="flex items-center justify-center md:justify-start gap-2 text-sm font-medium text-[#555]">
                <Star className="w-5 h-5 text-[#1A4392]" />
                <span>블랙벨트 직접 지도</span>
              </div>
            </div>
          </div>
          
        </div>
      </section>

      {/* Value Proposition */}
      <section className="py-8 md:py-16 px-4 bg-white/60 backdrop-blur-sm" id="features">
        <div className="max-w-7xl mx-auto text-center mb-6 md:mb-12">
          <h2 className="display-medium mb-2 md:mb-4 text-2xl md:text-5xl">바쁜 아이들을 위한<br/>'일석이조 솔루션'</h2>
          <p className="text-lg md:text-xl text-[#6B7280] max-w-2xl mx-auto leading-relaxed">
            학교, 숙제, 학원으로 바쁜 우리 아이.<br/>
            영어 따로, 운동 따로 보내야 한다면 시간도 돈도 두 배로 듭니다.
          </p>
        </div>

        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
          {[
            {
              title: "살아있는 영어의 가치",
              desc: "영어를 배움의 대상이 아닌 소통의 도구로 사용하여, 아이 스스로 영어의 필요성을 깨닫습니다.",
              icon: "🗣️"
            },
            {
              title: "도전을 통한 자신감",
              desc: "안전하고 깨끗한 환경에서 어려운 기술을 성공시키는 긍정적인 경험이 아이의 자존감을 키워줍니다.",
              icon: "🥋"
            },
            {
              title: "원어민 블랙벨트 지도",
              desc: "17년 수성구 영어 교육 경험과 11년 이상의 주짓수 수련을 가진 전문가가 지도합니다.",
              icon: "🏆"
            }
          ].map((item, i) => (
            <div key={i} className="network-card hover:bg-blue-50 border-blue-100 p-6 md:p-8 flex md:block items-start md:items-center text-left md:text-center gap-4 md:gap-0">
              <div className="text-4xl md:text-4xl mb-0 md:mb-4 shrink-0">{item.icon}</div>
              <div>
                <h3 className="text-xl md:text-2xl font-bold mb-1 md:mb-3 text-[#1A4392]">{item.title}</h3>
                <p className="text-base md:text-base text-[#6B7280] leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Proof Layer for Parent Search Intent */}
      <section className="py-8 md:py-16 px-4 bg-white/75 backdrop-blur-sm border-t border-blue-100/60">
        <div className="max-w-7xl mx-auto text-center mb-6 md:mb-10">
          <h2 className="display-medium mb-2 md:mb-4 text-2xl md:text-5xl">영어 스포츠로 찾는 부모님께</h2>
          <p className="text-lg md:text-xl text-[#6B7280] max-w-3xl mx-auto leading-relaxed">
            온더그라운드는 영어 학원도, 단순 놀이 수업도 아닙니다. 아이가 몸을 움직이며 영어 지시를 듣고 반응하는 영어 몰입형 스포츠 수업입니다.
          </p>
        </div>
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
          {[
            {
              title: "수성구 영어 스포츠",
              desc: "영어와 운동을 따로 보내기보다 한 수업 안에서 체력, 자신감, 영어 노출을 함께 만들고 싶은 가족에게 맞습니다."
            },
            {
              title: "영어 여름방학 활동",
              desc: "방학 중 새로운 활동을 찾는 아이에게 앉아서 하는 영어가 아니라 움직이며 듣고 반응하는 영어 경험을 제공합니다."
            },
            {
              title: "증명 가능한 수업 정보",
              desc: "대구 수성구 달구벌대로 2610 2층 위치, 네이버 플레이스, 전화 상담, 지도자 경력, 안전 기준을 공개해 부모님이 직접 확인할 수 있습니다."
            }
          ].map((item, i) => (
            <div key={i} className="network-card hover:bg-blue-50 border-blue-100 p-6 md:p-8 text-left">
              <h3 className="text-xl md:text-2xl font-bold mb-2 md:mb-3 text-[#1A4392]">{item.title}</h3>
              <p className="text-base md:text-base text-[#6B7280] leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="max-w-7xl mx-auto mt-6 md:mt-8 flex flex-col md:flex-row gap-3 justify-center">
          <a href="/suseong-gu-elementary-exercise-academy/" className="btn-secondary text-center bg-white/70">초등학생 운동 추천 보기</a>
          <a href="/daegu-body-based-english-class/" className="btn-secondary text-center bg-white/70">몸으로 배우는 영어 수업 보기</a>
          <a href="/english-sports-proof/" className="btn-primary text-center">영어 스포츠 근거 보기</a>
          <a href="/suseong-gu-english-summer-activities/" className="btn-secondary text-center bg-white/70">여름방학 활동 보기</a>
        </div>
      </section>

      {/* Coach Section - Moved Up */}
      <section className="py-8 md:py-16 px-4 bg-white/60 backdrop-blur-sm border-t border-gray-100/50">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-8 md:gap-12 items-center">
          <div className="w-full md:w-1/3">
             <img src={images.coachSitting} alt="Thomas Coach" className="rounded-[32px] shadow-xl w-full hover:scale-105 transition-transform duration-500" />
          </div>
          <div className="w-full md:w-2/3 space-y-6">
            <h2 className="heading-1 text-3xl md:text-4xl text-[#1A4392]">토마스 관장 <span className="text-lg md:text-lg font-normal text-[#6B7280] block md:inline mt-1 md:mt-0 font-sans">원어민 블랙벨트 지도자</span></h2>
            
            <div className="space-y-2 md:space-y-3">
              <div className="flex items-center gap-3 text-[#374151] font-medium text-base md:text-base">
                <CheckCircle2 className="w-5 h-5 text-[#1A4392]" /> 17년+ 수성구 영어 교육 경력
              </div>
              <div className="flex items-center gap-3 text-[#374151] font-medium text-base md:text-base">
                <CheckCircle2 className="w-5 h-5 text-[#1A4392]" /> 11년 주짓수 수련, 블랙벨트
              </div>
              <div className="flex items-center gap-3 text-[#374151] font-medium text-base md:text-base">
                <CheckCircle2 className="w-5 h-5 text-[#1A4392]" /> 어린이 교육 전문 과정 수료
              </div>
              <div className="flex items-center gap-3 text-[#374151] font-medium text-base md:text-base">
                <CheckCircle2 className="w-5 h-5 text-[#1A4392]" /> 철학과 언어학 전공
              </div>
            </div>

            <blockquote className="bg-blue-50 p-4 md:p-6 rounded-2xl italic text-lg md:text-lg text-[#1A4392] border-l-4 border-[#1A4392]">
              "주짓수를 통해 학생들에게 끈기, 자신감, 그리고 자기주도성과 같은 삶의 기술을 가르치고 싶습니다."
            </blockquote>
            
            <div className="pt-2 md:pt-4 w-full flex justify-center md:justify-start">
                <NaverPlaceLink />
            </div>
          </div>
        </div>
      </section>

      {/* Program Details */}
      <section className="py-8 md:py-16 px-4 relative overflow-hidden bg-white/60 backdrop-blur-sm" id="program">
        <div className="max-w-3xl mx-auto text-center space-y-6 md:space-y-8">
            <div className="inline-flex items-center gap-2 bg-white border border-[#1A4392] px-4 py-1 rounded-full text-sm font-bold text-[#1A4392] justify-center">
              <Sparkles className="w-4 h-4" /> 특별한 교육 시스템
            </div>
            <h2 className="display-medium text-3xl md:text-5xl">
              영어의 가치를<br/>'지금' 느끼게 합니다
            </h2>
            <p className="text-lg md:text-lg text-[#374151]">
              영어로 듣고, 움직이고, 웃으며 말하는 순간 아이 스스로 깨닫습니다.<br/>
              "영어는 재미있고, 지금 바로 쓸 수 있구나!"
            </p>
            
            <ul className="space-y-3 md:space-y-4 text-left max-w-lg mx-auto">
              {[
                "English + Fitness = Confidence",
                "축구/농구/피구보다 부상률이 낮은 안전한 운동",
                "아이 눈높이에 맞춘 친절한 설명",
                "매일 청소되는 깨끗한 환경"
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-lg md:text-lg font-medium text-[#1A4392] justify-center md:justify-start">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-[#E63946] fill-white shrink-0" />
                  {item}
                </li>
              ))}
            </ul>

            <div className="flex gap-3 md:gap-4 flex-col items-center justify-center w-full">
                <NaverBookingCTA className="w-full md:w-auto" />
                <button onClick={handleConsultation} className="btn-secondary mt-2 text-base md:text-lg w-full md:w-auto">
                커리큘럼 확인하기
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-8 md:mt-12 relative">
               {/* Click Hint */}
               <div className="absolute -top-8 left-1/2 -translate-x-1/2 z-20 flex items-center animate-bounce pointer-events-none whitespace-nowrap">
                  <span className="bg-[#E63946] text-white text-base md:text-base font-bold px-4 py-1.5 rounded-full shadow-lg border-2 border-white">
                    👇 클릭
                  </span>
               </div>

               {[images.feature1, images.feature3, images.feature2].map((src, i) => (
                 <Dialog key={i}>
                    <DialogTrigger asChild>
                       <div className="rounded-[32px] overflow-hidden shadow-xl aspect-[4/3] group cursor-zoom-in relative border-4 border-white hover:border-[#1A4392] transition-colors">
                          <img 
                            src={src} 
                            alt={`Class Activity ${i+1}`} 
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" 
                            loading="lazy"
                          />
                          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                              <span className="bg-white/90 text-[#1A4392] text-sm font-bold px-4 py-2 rounded-full opacity-0 group-hover:opacity-100 transition-all transform translate-y-4 group-hover:translate-y-0 shadow-lg">
                                🔍 크게 보기
                              </span>
                          </div>
                       </div>
                    </DialogTrigger>
                    <DialogContent className="max-w-[95vw] max-h-[95vh] w-auto h-auto p-0 bg-transparent border-none shadow-none flex justify-center items-center outline-none [&>button]:text-white [&>button]:bg-black/20 [&>button]:rounded-full [&>button]:p-1">
                       <div className="relative w-auto h-auto max-w-full max-h-full overflow-hidden rounded-lg bg-white">
                         <img
                           src={src}
                           alt="Class Activity Fullscreen"
                           className="w-auto h-auto max-w-[90vw] max-h-[90vh] object-contain"
                         />
                       </div>
                    </DialogContent>
                 </Dialog>
               ))}
            </div>
        </div>
      </section>

      {/* Photo Gallery */}
      <section className="py-8 md:py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-center text-2xl md:text-4xl font-bold mb-6 md:mb-10 text-[#1A4392]">
             즐거운 수련 현장
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
             {[images.gallery1, images.gallery2, images.gallery3, images.gallery4].map((src, i) => (
                <Dialog key={i}>
                  <DialogTrigger asChild>
                    <div className="rounded-2xl overflow-hidden shadow-lg h-48 md:h-64 bg-gray-100 cursor-zoom-in relative group">
                       <img 
                         src={src} 
                         alt={`Gallery ${i}`} 
                         className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" 
                         loading="lazy" 
                       />
                       <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                          <span className="bg-white/90 text-[#1A4392] text-sm md:text-sm font-bold px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-all transform translate-y-2 group-hover:translate-y-0 shadow-md">
                            🔍
                          </span>
                       </div>
                    </div>
                  </DialogTrigger>
                  <DialogContent className="max-w-[95vw] max-h-[95vh] w-auto h-auto p-0 bg-transparent border-none shadow-none flex justify-center items-center outline-none [&>button]:text-white [&>button]:bg-black/20 [&>button]:rounded-full [&>button]:p-1">
                     <div className="relative w-auto h-auto max-w-full max-h-full overflow-hidden rounded-lg bg-white">
                       <img
                         src={src}
                         alt="Gallery Fullscreen"
                         className="w-auto h-auto max-w-[90vw] max-h-[90vh] object-contain"
                       />
                     </div>
                  </DialogContent>
                </Dialog>
             ))}
          </div>
        </div>
      </section>

      {/* Reviews Carousel */}
      <section className="py-8 md:py-16 px-4 bg-[#1A4392]/90 backdrop-blur-sm text-white" id="reviews">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-6 md:mb-10">
            <h2 className="text-3xl md:text-5xl font-bold mb-2 md:mb-4 text-white font-['Poppins']">
              학부모님들의 리얼 후기
            </h2>
            <p className="text-blue-200 text-xl md:text-xl">이미지를 클릭하면 크게 볼 수 있습니다</p>
          </div>

          <div className="max-w-5xl mx-auto">
             <Carousel
                opts={{
                    align: "start",
                    loop: true,
                }}
                className="w-full"
             >
                <CarouselContent className="-ml-4">
                    {reviews.map((src, index) => (
                        <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3 h-[400px] md:h-[500px]">
                            <div className="p-1 h-full">
                              <Dialog>
                                <DialogTrigger asChild>
                                  <Card className="border-0 overflow-hidden rounded-[20px] cursor-zoom-in group h-full shadow-lg hover:shadow-2xl transition-shadow">
                                      <CardContent className="p-0 h-full relative bg-gray-100">
                                          <img 
                                              src={src} 
                                              alt={`Review ${index + 1}`} 
                                              loading="lazy"
                                              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                                          />
                                          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                                              <span className="bg-white/90 text-blue-900 text-sm font-bold px-4 py-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity translate-y-4 group-hover:translate-y-0 duration-300 shadow-md">
                                                크게 보기
                                              </span>
                                          </div>
                                      </CardContent>
                                  </Card>
                                </DialogTrigger>
                                <DialogContent className="max-w-[95vw] max-h-[95vh] w-auto h-auto p-0 bg-transparent border-none shadow-none flex justify-center items-center outline-none [&>button]:text-white [&>button]:bg-black/20 [&>button]:rounded-full [&>button]:p-1">
                                   <div className="relative w-auto h-auto max-w-full max-h-full overflow-hidden rounded-lg bg-white">
                                     <img
                                       src={src}
                                       alt="Review Fullscreen"
                                       className="w-auto h-auto max-w-[90vw] max-h-[90vh] object-contain"
                                     />
                                   </div>
                                </DialogContent>
                              </Dialog>
                            </div>
                        </CarouselItem>
                    ))}
                </CarouselContent>
                <CarouselPrevious className="flex -left-6 md:-left-24 bg-white hover:bg-red-50 text-[#E63946] border-4 border-[#E63946] shadow-2xl z-10 h-16 w-16 md:h-24 md:w-24 [&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-12 md:[&>svg]:w-12 rounded-full transition-transform hover:scale-110" />
                <CarouselNext className="flex -right-6 md:-right-24 bg-white hover:bg-red-50 text-[#E63946] border-4 border-[#E63946] shadow-2xl z-10 h-16 w-16 md:h-24 md:w-24 [&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-12 md:[&>svg]:w-12 rounded-full transition-transform hover:scale-110" />
             </Carousel>
          </div>
          
          <div className="text-center mt-8 md:mt-12">
            <a 
                href="https://map.naver.com/p/entry/place/1096514067"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex btn-cta bg-white text-[#1A4392] hover:bg-gray-100 shadow-none text-base md:text-xl px-6 py-3 md:px-10 md:py-5 min-h-[48px] md:min-h-[60px] items-center justify-center font-bold rounded-full"
            >
                더 많은 후기 보러가기
            </a>
          </div>
        </div>
      </section>

      {/* Pricing / Offer */}
      <section className="py-8 md:py-16 px-4 bg-white/60 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto bg-white/90 backdrop-blur-xl rounded-[32px] md:rounded-[40px] shadow-2xl overflow-hidden border border-blue-200 relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-50 rounded-full blur-3xl -z-10 -translate-y-1/2 translate-x-1/2"></div>
          <div className="bg-[#1A4392] text-white p-8 md:p-12 text-center overflow-hidden">
            <span className="bg-[#E63946] text-white px-4 py-1.5 rounded-full font-bold text-xs md:text-sm uppercase tracking-wider mb-6 inline-block shadow-lg">Limited Offer</span>
            <h2 className="text-xl md:text-2xl font-medium mb-8 font-['Poppins'] text-blue-100">100% 환불 보장 + 무료 체험</h2>
            
            <div className="relative inline-block">
                {/* Decorative Arrows (Desktop) */}
                <div className="absolute top-1/2 -left-16 -translate-y-1/2 hidden md:block animate-bounce">
                    <ArrowRight className="w-12 h-12 text-[#D3FF62]" />
                </div>
                <div className="absolute top-1/2 -right-16 -translate-y-1/2 hidden md:block animate-bounce">
                    <ArrowRight className="w-12 h-12 text-[#D3FF62] rotate-180" />
                </div>

                {/* Mobile Arrow (Top) */}
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 md:hidden animate-bounce">
                    <ArrowRight className="w-8 h-8 text-[#D3FF62] rotate-90" />
                </div>

                <p className="text-white text-4xl md:text-6xl font-black leading-tight drop-shadow-2xl">
                    리스크 <span className="text-[#D3FF62]">0%</span>,<br/>
                    성장 가능성 <span className="text-[#D3FF62]">100%</span>
                </p>
            </div>
          </div>
          
          <div className="p-6 md:p-12">
             <div className="space-y-6 md:space-y-8 mb-8 md:mb-10">
               <div className="flex items-start gap-3 md:gap-4 group">
                 <div className="bg-blue-50 p-3 md:p-4 rounded-2xl group-hover:bg-blue-100 transition-colors shrink-0">
                   <span className="text-2xl md:text-2xl">🎁</span>
                 </div>
                 <div>
                   <h3 className="text-xl md:text-xl font-bold text-[#1A4392]">무료 체험 수업 1회</h3>
                   <p className="text-base md:text-base text-[#6B7280]">30,000원 상당 - 아이가 직접 경험 후 결정합니다</p>
                 </div>
               </div>
               
               <div className="flex items-start gap-3 md:gap-4 group">
                 <div className="bg-blue-50 p-3 md:p-4 rounded-2xl group-hover:bg-blue-100 transition-colors shrink-0">
                   <span className="text-2xl md:text-2xl">🥋</span>
                 </div>
                 <div>
                   <h3 className="text-xl md:text-xl font-bold text-[#1A4392]">무료 도복 증정</h3>
                   <p className="text-base md:text-base text-[#6B7280]">100,000원 상당 - 첫날부터 자신감 있게 시작</p>
                 </div>
               </div>

               <div className="flex items-start gap-3 md:gap-4 group">
                 <div className="bg-blue-50 p-3 md:p-4 rounded-2xl group-hover:bg-blue-100 transition-colors shrink-0">
                   <span className="text-2xl md:text-2xl">📈</span>
                 </div>
                 <div>
                   <h3 className="text-xl md:text-xl font-bold text-[#1A4392]">맞춤형 성장 보고서 제공</h3>
                   <p className="text-base md:text-base text-[#6B7280]">25,000원 상당 – 아이의 변화와 발전을 한눈에 확인</p>
                 </div>
               </div>
               <div className="flex items-start gap-3 md:gap-4 group">
                 <div className="bg-blue-50 p-3 md:p-4 rounded-2xl group-hover:bg-blue-100 transition-colors shrink-0">
                   <span className="text-2xl md:text-2xl">🎒</span>
                 </div>
                 <div>
                   <h3 className="text-xl md:text-xl font-bold text-[#1A4392]">무료 도복 가방 증정</h3>
                   <p className="text-base md:text-base text-[#6B7280]">5,000원 상당 - 튼튼하고 실용적인 전용 가방</p>
                 </div>
               </div>
             </div>

             <div className="text-center p-4 md:p-6 bg-blue-50 rounded-2xl border border-blue-100 mb-6 md:mb-8">
               <p className="font-bold text-[#1A4392] text-lg md:text-lg mb-1">총 혜택: 160,000원 상당</p>
               <p className="text-sm md:text-sm text-[#6B7280]">만족하지 않으면 전액 환불해드립니다</p>
             </div>

             <div className="flex flex-col gap-6 items-center w-full">
                <NaverBookingCTA className="w-full" />
                <p className="text-center text-xs md:text-xs text-gray-400">선착순 마감될 수 있습니다.</p>
             </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-8 md:py-16 px-4 bg-white">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-bold mb-2 md:mb-4 text-[#1A4392]">자주 묻는 질문 (FAQ)</h2>
            <p className="text-base md:text-lg text-[#6B7280]">궁금한 점을 미리 확인해보세요</p>
          </div>
          
          <Accordion type="single" collapsible className="w-full space-y-4">
            {[
              {
                q: "영어를 전혀 못해도 괜찮나요?",
                a: "네, 괜찮습니다. 영어 실력과 상관없이 누구나 자연스럽게 따라오도록 수업이 진행됩니다."
              },
              {
                q: "다치지는 않나요?",
                a: "철저한 안전 규칙과 단계별 지도 방식을 기반으로 수업이 진행됩니다. 통계적으로도 축구, 배구, 복싱 등 흔히 접하는 스포츠보다 부상률이 낮아 안전합니다."
              },
              {
                q: "여학생도 있나요?",
                a: "네, 여학생들도 참여하고 있습니다. 성별과 관계없이 누구나 즐길 수 있는 운동입니다."
              },
              {
                q: "처음 오는 아이도 잘 따라갈 수 있나요?",
                a: "네. 처음 오는 아이들을 위해 기본 움직임과 동작부터 차근차근 지도합니다."
              },
              {
                q: "도복이 꼭 필요한가요?",
                a: "네, 필요합니다. 하지만 가입 시 무료로 제공해드립니다."
              },
              {
                q: "체험 수업이 가능한가요?",
                a: "네. 무료 체험 수업을 제공하고 있으며, 아이가 분위기와 운동을 직접 경험해볼 수 있습니다."
              },
              {
                q: "몇 살부터 수업을 들을 수 있나요?",
                a: "초등학교 4학년부터 중·고등학생까지 참여할 수 있으며, 각 연령대가 자연스럽게 따라올 수 있도록 수업을 구성합니다."
              },
              {
                q: "반 정원은 어떻게 되나요?",
                a: "수업은 최대 12명 정원으로 운영되며, 모든 아이가 충분한 지도와 안전한 환경 속에서 수업을 받을 수 있도록 합니다."
              },
              {
                q: "주차가 가능한가요?",
                a: "네이버 플레이스에 주차 편의가 표시되어 있습니다. 현장 상황에 따라 인근 주차장을 이용할 수 있으니 방문 전 네이버 플레이스 또는 전화로 확인해주세요."
              }
            ].map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border rounded-2xl px-4 bg-white shadow-sm">
                <AccordionTrigger className="text-left font-bold text-[#1A4392] text-base md:text-lg py-4 hover:no-underline">
                  Q. {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 text-base pb-4 leading-relaxed">
                  A. {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
      {/* Final CTA Section */}
      <section className="py-12 px-4 bg-[#1A4392] text-white text-center">
        <div className="max-w-3xl mx-auto space-y-8 flex flex-col items-center">
          <div>
            <h2 className="text-3xl font-bold font-['Poppins'] mb-2">Ready to Start?</h2>
            <p className="text-xl text-blue-100">지금 바로 상담을 예약하고 혜택을 놓치지 마세요.</p>
          </div>
          
          <div className="w-full max-w-md bg-white/10 p-6 rounded-3xl backdrop-blur-sm border border-white/20">
            <button 
              onClick={() => window.open("https://map.naver.com/p/entry/place/1096514067", "_blank", "noopener,noreferrer")}
              className="w-full bg-[#03C75A] text-white font-bold py-4 px-8 rounded-xl shadow-lg hover:brightness-105 transition-all flex items-center justify-center gap-2 text-xl mb-3"
            >
              <span className="font-extrabold">N</span>
              <span>네이버에서 예약하기</span>
            </button>
            <p className="text-sm font-medium text-blue-100 mb-1">
              버튼 클릭 → 네이버 페이지 이동 → ‘상담예약’ 클릭
            </p>
            <p className="text-xs text-blue-200/80 flex items-center justify-center gap-1">
              <Shield className="w-3 h-3" />
              네이버 공식 페이지에서 안전하게 예약 가능합니다
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0F172A] text-white pt-12 pb-8 md:pt-20 md:pb-10 px-4" id="location">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-16">
          <div>
            <h3 className="text-2xl font-bold mb-6 font-['Poppins']">ONTHEGROUND</h3>
            <p className="opacity-70 mb-6 leading-relaxed">영어와 운동을 함께 배우는<br/>대구 유일의 프리미엄 키즈 주짓수</p>
            <div className="flex gap-4">
              <a href="https://instagram.com/onthegroundbjj" target="_blank" className="bg-white/10 p-3 rounded-full hover:bg-[#E1306C] transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-6 text-[#E63946] font-['Poppins']">Contact</h4>
            <ul className="space-y-4 opacity-80">
              <li className="flex items-center gap-3"><Phone className="w-4 h-4" /> 010-9879-0818</li>
              <li className="flex items-center gap-3"><Instagram className="w-4 h-4" /> @onthegroundbjj</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-[#E63946] font-['Poppins']">Location</h4>
            <p className="opacity-80 flex gap-2 leading-relaxed mb-4">
              <MapPin className="w-5 h-5 shrink-0" />
              대구 수성구 달구벌대로 2610 2층<br/>만촌역 3번 출구에서 232m
            </p>
            <a 
              href="https://map.naver.com/p/entry/place/1096514067" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block w-28 rounded-2xl overflow-hidden bg-white shadow-lg border border-white/20 hover:scale-[1.02] transition-transform duration-300 group relative"
            >
               <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors z-10 flex items-center justify-center">
                  <span className="bg-[#03C75A] text-white text-[10px] font-bold px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-all transform translate-y-2 group-hover:translate-y-0 shadow-md whitespace-nowrap">
                    지도 보기
                  </span>
               </div>
               <img 
                 src="https://customer-assets.emergentagent.com/job_ontheground-bjj/artifacts/na9l4hfc_image.png"
                 alt="Naver Map"
                 className="w-full h-auto object-cover"
               />
            </a>
          </div>

          <div>
             <button onClick={handleConsultation} className="w-full bg-white text-[#0F172A] py-4 rounded-xl font-bold hover:bg-blue-50 transition-colors shadow-lg">
               무료 상담 예약하기
             </button>
          </div>
        </div>

        <div className="max-w-7xl mx-auto border-t border-white/10 pt-8 pb-8">
          <h4 className="text-lg font-bold mb-4 text-[#E63946] font-['Poppins'] text-center md:text-left">지역별 안내</h4>
          <div className="flex flex-wrap justify-center md:justify-start gap-3 text-sm">
            <a href="/jiu-jitsu-suseong-gu-daegu/" className="text-white/70 hover:text-white transition-colors border border-white/10 rounded-full px-3 py-1.5">
              수성구 주짓수
            </a>
            <a href="/jiu-jitsu-manchon-dong/" className="text-white/70 hover:text-white transition-colors border border-white/10 rounded-full px-3 py-1.5">
              만촌동 주짓수
            </a>
            <a href="/kids-jiu-jitsu-suseong-gu/" className="text-white/70 hover:text-white transition-colors border border-white/10 rounded-full px-3 py-1.5">
              수성구 키즈 주짓수
            </a>
            <a href="/suseong-gu-kids-sports/" className="text-white/70 hover:text-white transition-colors border border-white/10 rounded-full px-3 py-1.5">
              수성구 어린이 운동
            </a>
            <a href="/suseong-gu-elementary-exercise-academy/" className="text-white/70 hover:text-white transition-colors border border-white/10 rounded-full px-3 py-1.5">
              초등학생 운동 학원
            </a>
            <a href="/daegu-body-based-english-class/" className="text-white/70 hover:text-white transition-colors border border-white/10 rounded-full px-3 py-1.5">
              몸으로 배우는 영어
            </a>
            <a href="/suseong-gu-taekwondo-alternative/" className="text-white/70 hover:text-white transition-colors border border-white/10 rounded-full px-3 py-1.5">
              태권도 대안
            </a>
            <a href="/manchon-dong-children-sports/" className="text-white/70 hover:text-white transition-colors border border-white/10 rounded-full px-3 py-1.5">
              만촌동 키즈 스포츠
            </a>
            <a href="/suseong-gu-bjj-faq/" className="text-white/70 hover:text-white transition-colors border border-white/10 rounded-full px-3 py-1.5">
              주짓수 FAQ
            </a>
          </div>
        </div>
        
        <div className="max-w-7xl mx-auto border-t border-white/10 pt-8 text-center text-sm opacity-50 font-light">
          <p>&copy; 2025 ONTHEGROUND 주짓수. All rights reserved.</p>
          <div className="mt-4 flex justify-center gap-3">
            <a 
              href="/affiliates" 
              className="inline-flex items-center gap-2 text-white/60 hover:text-[#E63946] transition-colors text-xs font-medium px-3 py-1.5 rounded-full border border-white/10 hover:border-[#E63946]/30 hover:bg-white/5"
            >
              <Gift className="w-3 h-3" />
              추천인 리워드 안내
            </a>
            <a 
              href="/winter" 
              className="inline-flex items-center gap-2 text-white/60 hover:text-[#93C5FD] transition-colors text-xs font-medium px-3 py-1.5 rounded-full border border-white/10 hover:border-[#93C5FD]/30 hover:bg-white/5"
            >
              <Snowflake className="w-3 h-3" />
              겨울방학 캠프
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
